import React, { Component } from 'react';
import Simple from './Table';


class Store extends Component {
  render() {
    return (
      <Simple />
    );
  }
}


export default Store;



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/Category/index.js